// src/ui/CurrencyDropdown.js
const CURRENCIES = [
  { code: 'MAD', flag: '🇲🇦', name: 'Moroccan Dirham' },
  { code: 'EUR', flag: '🇪🇺', name: 'Euro' },
  { code: 'USD', flag: '🇺🇸', name: 'US Dollar' },
  { code: 'GBP', flag: '🇬🇧', name: 'British Pound' },
  { code: 'CAD', flag: '🇨🇦', name: 'Canadian Dollar' },
  { code: 'AED', flag: '🇦🇪', name: 'UAE Dirham' },
  { code: 'SAR', flag: '🇸🇦', name: 'Saudi Riyal' },
];

export class CurrencyDropdown {
  constructor({ onSelect }) {
    this._onSelect = onSelect;
    this._current = 'USD';
    this._el = this._build();
    this._bindClose();
  }

  get element() { return this._el; }

  _build() {
    const el = document.createElement('div');
    el.className = 'currency-dropdown';
    el.setAttribute('role', 'listbox');
    el.innerHTML = CURRENCIES.map((c) => `
      <button class="dropdown-item" role="option" data-code="${c.code}"
        aria-label="${c.flag} ${c.code} – ${c.name}">
        <span>${c.flag}</span>
        <span>${c.code}</span>
        <span style="color:var(--tmuted);font-size:13px;font-weight:300;">${c.name}</span>
      </button>
    `).join('');

    el.addEventListener('click', (e) => {
      const btn = e.target.closest('[data-code]');
      if (!btn) return;
      this._select(btn.dataset.code);
    });

    return el;
  }

  _select(code) {
    this._current = code;
    this._el.querySelectorAll('[data-code]').forEach((btn) => {
      btn.classList.toggle('active', btn.dataset.code === code);
    });
    this.close();
    this._onSelect(code);
  }

  open(anchorEl) {
    const rect = anchorEl.getBoundingClientRect();
    this._el.style.top = `${rect.bottom + 8 + window.scrollY}px`;
    this._el.style.left = `${rect.left}px`;
    this._el.classList.add('open');
  }

  close() {
    this._el.classList.remove('open');
  }

  toggle(anchorEl) {
    if (this._el.classList.contains('open')) {
      this.close();
    } else {
      this.open(anchorEl);
    }
  }

  setCurrent(code) {
    this._current = code;
    this._el.querySelectorAll('[data-code]').forEach((btn) => {
      btn.classList.toggle('active', btn.dataset.code === code);
    });
  }

  _bindClose() {
    document.addEventListener('click', (e) => {
      if (!this._el.contains(e.target) && !e.target.closest('.currency-pill')) {
        this.close();
      }
    });
  }
}
